import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { TYPE_META } from "@/lib/api";

const EMPTY = { casino: "", bonus_type: "free_sc", title: "", value: "", est_value: 0, promo_code: "", link: "", instructions: "", states: "Most US states", expires: "", active: true };
const FIELDS = [["casino", "Casino"], ["title", "Offer title"], ["value", "Display value (e.g. 5 SC)"], ["est_value", "Est. USD value"], ["promo_code", "Promo code"], ["link", "Claim link"], ["states", "Eligible states"], ["expires", "Expires"]];

export const BonusForm = ({ open, onOpenChange, initial, onSave }) => {
  const [f, setF] = useState(EMPTY);
  useEffect(() => { setF(initial ? { ...EMPTY, ...initial } : EMPTY); }, [initial, open]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    onSave({ ...f, est_value: parseFloat(f.est_value) || 0 });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0F131D] border-white/10 text-white sm:max-w-lg max-h-[90vh] overflow-y-auto" data-testid="bonus-form-dialog">
        <DialogHeader><DialogTitle className="font-display">{initial?.id ? "Edit offer" : "New offer"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid grid-cols-2 gap-3">
          <select value={f.bonus_type} onChange={set("bonus_type")} data-testid="bonus-form-type" className="col-span-2 h-10 rounded-md bg-[#07090E] border border-white/10 px-3 text-sm">
            {Object.entries(TYPE_META).map(([k, m]) => <option key={k} value={k}>{m.label}</option>)}
          </select>
          {FIELDS.map(([k, l]) => (
            <Input key={k} required={["casino", "title"].includes(k)} value={f[k]} onChange={set(k)} placeholder={l} data-testid={`bonus-form-${k.replace("_", "-")}`} className={`bg-[#07090E] ${["title", "link"].includes(k) ? "col-span-2" : ""}`} />
          ))}
          <Textarea value={f.instructions} onChange={set("instructions")} placeholder="How to claim" data-testid="bonus-form-instructions" className="col-span-2 bg-[#07090E]" />
          <label className="col-span-2 flex items-center gap-3 text-sm text-slate-300">
            <Switch checked={f.active} onCheckedChange={(v) => setF({ ...f, active: v })} data-testid="bonus-form-active" /> Visible to customers
          </label>
          <button type="submit" data-testid="bonus-form-save" className="col-span-2 h-11 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#07090E] font-bold transition-colors">Save offer</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
